// extracted by mini-css-extract-plugin
export default {"help":"help2_help__TptOn","reverse":"help2_reverse__wZt5c"};